import React from 'react'
import { motion } from 'framer-motion' // Import Motion

const Journey = () => {
    // Animation variant for a smooth reveal
    const revealVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 2, ease: "easeOut" } 
        }
    };

    return (
        <section className='journey h-75'>
            <div className="overlay">
                <motion.div 
                    className="w-80"
                    initial="hidden"
                    whileInView="visible" 
                    viewport={{ once: false, amount: 0.3 }} // Settings for repeat animation
                    variants={revealVariant}
                >
                    <h2 className="h2-light">
                        Every project starts with a story of adaptability and growth across borders
                    </h2>
                    <div className="wrapper">
                        <div className="description">  
                            <p className="text-primary">
                                From the precision of high-volume wholesale inventory and retail mastery in 
                                Cape Town to electrical apprenticeships in Nairobi, I’ve built a career on 
                                reliability, technical grit, and multilingual communication. 
                                My background as a Grocery Clerk and Delicatessen Professional taught me 
                                the operational discipline I now bring to engineering and code.
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    )
}

export default Journey